<template>
  <SearchBox
    label="Natureza de Operação:"
    ref="searchbox"
    placeholder="Busca Natureza de Operação por Nome ou Código"
    funcaoBuscar="getNaturezasOperacaoBox"
    @selected="handleSelected"
  />
</template>

<style lang="scss" scoped></style>

<script>
import SearchBox from "./SearchBox.vue";

export default {
  name: "SearchBoxNaturezaOperacao",
  data() {
    return {
      item: {}
    };
  },
  props: ["value"],
  components: {
    SearchBox
  },
  methods: {
    handleSelected(item) {
      this.item = item;
      if (item.ID) {
        this.$emit("input", item.ID);
        this.$emit("descricao", item.DESCRICAO);
        this.$emit("update:modelValue", item.ID);
        this.$emit("change", {});
      } else {
        this.$emit("input", "");
        this.$emit("descricao", "");
        this.$emit("update:modelValue", "");
        this.$emit("change", {});
      }
    },
    selecionar(item) {
      this.item = item;
      this.$refs.searchbox.selecionarItemExterno(item);
    },
    apagar() {
      this.$refs.searchbox.apagar(true);
    },
    obterItem() {
      return this.item;
    }
  }
};
</script>
